import React, { useState } from 'react';

import { Box, Text, Flex, Image, Modal, ModalOverlay, ModalBody, ModalContent, Skeleton } from '@chakra-ui/react';
import { AiFillCheckCircle } from 'react-icons/ai'
import MakeTemplateTutorialImage from './styles/images/make-template-tutorial.png';
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';
import LaunchdeckCloseButton from '../../../global/components/helper-components/components/LaunchdeckCloseButton';
import { displayEmoji } from '../../helpers/dsr-helpers';


export default function CreateTemplatesTutorialModal({handleCloseModal}) {

    return (
      <Modal isOpen={true} closeOnOverlayClick={false} isCentered={true} >
        <ModalOverlay />
        <ModalContent rounded='0.25em' minW={['90%', '90%', '50%', '50%']}  >
          <ModalBody>
            <Flex direction='column' justify='space-around' alignItems='center' w='100%'>
              <Flex justify='space-between' align='center' w='100%' borderBottom='1px solid' borderBottomColor='gray.300'>
                <Flex px='1em' justify='flex-start' align='center'>
                  <Box as={AiFillCheckCircle} color='brand.500'
                    boxSize="1.6em" />
                  <Box px='1.5em' py='0.5em' color='brandDark.500'>Tutorial: Creating a Room Template</Box>
                </Flex>

                <Box pr='1.5em'>
                    <LaunchdeckCloseButton handleCloseModal={() => handleCloseModal()} />
                </Box>
              </Flex>

              <React.Fragment>
                <Flex direction='column' justify='space-around' alignItems='center' w='100%'>

                  <Flex direction='column' position='relative' bg='white' m='auto'>
                    <Flex direction='column' justify='center' align='center' minHeight='70vh' px='2em' w='100%' position='relative'>
                      <DisplayContent handleCloseModal={handleCloseModal} />
                      <Flex justify='flex-end' w='100%' px='1.5em' pb='1em' position='absolute' bottom='0.1em'>
                        
                      </Flex>
                    </Flex>
                  </Flex>
                </Flex>
              </React.Fragment>

            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
      
    );

}



function DisplayContent({ handleCloseModal }) {
  const [imageClassName, setImageClassName] = useState('image-loading__in-progress')
  return (
    <Flex direction='column' alignItems='center' justify='center' w='100%'>
      <Flex direction='column' alignItems='center' justify='center' w='100%'>
        <Box >
          <Skeleton height="200px" width="200px" display={(imageClassName === 'image-loading__in-progress' ? 'unset' : 'none')} />
          <Image src={MakeTemplateTutorialImage} className={imageClassName}
            visibility={(imageClassName === 'image-loading__in-progress' ? 'none' : '')}
            onLoad={() => setImageClassName('image-loading__completed')} 
            // objectFit="cover" 
            width='26em'
            alt="Make Room Template tutorial" />
        </Box>

        {/* <Box fontSize='1.5em' lineHeight='1.875em' fontWeight='500' mt='0.2em'>Invite others to join the Room</Box> */}

        <Box w='100%' fontSize='0.9em' mt='1em' fontWeight='400' lineHeight='1.375em'>
          <Text textAlign='center' mt='0.5em' my={['1em', '0em', '0em', '0em']}>Hover across a published Room & select <i>Make template</i> option.</Text>
          <Flex align='center' justify='center' gap={4} mt='1em'>
          And that's it! 		<span>{displayEmoji('celebrate')} </span>
          </Flex>
        </Box>

        <Box mt='3em'>
          <LaunchdeckButton bg='brand.500' color='white' px='2em' onClick={() => handleCloseModal()} label='OK, got it' />
        </Box>
      </Flex>
    </Flex>
  )
}
